<div class="container pt-15 pt-md-17 pb-16 pb-md-18">

    <div class="row gx-lg-0 gy-10 align-items-center reverse" style="align-items:unset !important;">
      <div class="col-lg-6 order-lg-2 ms-lg-auto" style="margin-top: 60px;">

        <div class="card rounded-xl me-lg-6 bg-soft-yellow mb-25" [ngClass]="{'hide' : !step.title && !step.description}"
        *ngFor="let step of ourWorkingProcessData?.process?.steps, let index = index">
          <div class="card-body p-6">
            <div class="d-flex flex-row">
              <div>
                <span class="icon btn btn-block btn-lg shadow-xl rounded-xl btn-white pe-none me-4">
                  <span class="number text-primary">{{index + 1}}</span>
                </span>
              </div>
              <div>
                <h3 class="mb-1 text-primary">{{step.title}}</h3>
                <p class="mb-0">{{step.description}}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="card rounded-xl mx-lg-6 mt-6 bg-pale-primary">
        </div>
      </div>

      <div class="col-lg-5 text-inverse">
        <h2 class="display-2 mb-25 text-white">{{ourWorkingProcessData?.process?.title}}</h2>
        <p class="lead fs-lg pe-lg-5" [innerHTML]="ourWorkingProcessData?.process?.description"></p>
        <div class="btn-container mb-18">
        <button mat-raised-button class="btn btn-primary rounded-xl mb-0" aria-label="about-us" (click)="navigate()">
              <span>{{ 'langs.learn_more' | translateWithKeys }}</span>
        </button>
        </div>
      </div>
    </div>

  </div>
